import { createContext } from 'react';
//
import { WsContextType } from './types';

// ----------------------------------------------------------------------

const WsContext = createContext({} as WsContextType);

export default WsContext;
